import { Image, ImageOutlined } from "@mui/icons-material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { Subtype } from "./subtype";
import { PictureUploadEditorPreview } from "../../../components/actionModules/subtypes/pictureUpload/PictureUploadEditorPreview";
import PictureUploadSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/PictureUploadSubtypeDetails";
import { PictureUploadSubtypeResponse, PictureUploadSubtypeDataModel } from "./pictureUploadSubtype";
import PictureUploadSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/PictureUploadSubtypeSummary";

export const PictureUploadSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.pictureUpload.name",
    type: Subtype.PictureUploadModuleSubtype,
    icon: <Image />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<ImageOutlined />}
        name="actionModules.subtypes.pictureUpload.name" />,
    editorPreview: PictureUploadEditorPreview,
    subtypeDataView: (props) => <PictureUploadSubtypeDetails
        subtype={props.subtype as PictureUploadSubtypeResponse}
        subtypeData={props.subtypeData as PictureUploadSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <PictureUploadSubtypeSummary
        subtype={props.subtype as PictureUploadSubtypeResponse}
        subtypeData={props.subtypeData as PictureUploadSubtypeDataModel} />,
    editableProperties: [
        {
            name: "pictureDescription",
            displayName: "actionModules.subtypes.pictureUpload.pictureDescription",
            propertyType: PropertyTypes.text
        },
        {
            name: "exampleImageUrl",
            displayName: "actionModules.subtypes.pictureUpload.exampleImageUrl",
            propertyType: PropertyTypes.text
        },
    ]
};
